var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-container',{staticClass:"pb-0 mt-2 px-5",attrs:{"fluid":""}},[_c('iframe',{attrs:{"src":"https://qaraterp.com/","width":"100%","height":_vm.$store.state.Settings.windowSize.y - 100,"frameborder":"0"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }